import { useSelector } from "react-redux";
import AdvisorDuplicateMap from "../../../components/DataCollection/Advisor/AdvisorDuplicateMap/AdvisorDuplicateMap";
import { selectUserData } from "../../../features/userSlice";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import Page404 from "../../../components/Page404/Page403";

export const AdvisorDuplicateMapScreen = () => {
  const userData = useSelector(selectUserData);
  const hasPermission = CheckPermissions(
    userData?.data?.products?.data_collection,
    "businesse_advisor",
    "create_edit_delete_advisor_maps_&_gap_rules",
  );

  return <div>{!hasPermission ? <Page404 /> : <AdvisorDuplicateMap />}</div>;
};
